import { useCallback, useMemo, useState } from 'react';
import useLoadWorkplaces from './functions/useLoadWorkplaces';
import useSearches from './functions/useSearches';
import useUpdateWorkplaceStatus from './functions/useUpdateWorkplaceStatus';
import useDownloadExcel from './functions/useDownloadExcel';
import useUploadFile from './functions/useUploadFile';

export default function useWorkplaces() {
  const [currentPage, setCurrentPage] = useState(1);

  const {
    isLoadLoading,
    workplaces,
    doesListApiHasError,
    filteredWorkplaces,
    setFilteredWorkplaces,
    loadWorkplaces,
    workplacesSplitted,
    setWorkplacesSplitted,
    fullWorkplacesInfo,
  } = useLoadWorkplaces({ setCurrentPage });

  const {
    selectedStatus,
    handleStatusChange,
    workplaceCode,
    handleWorkplaceCodeChange,
    streetName,
    handleStreetNameChange,
    workplaceName,
    handleWorkplaceNameChange,
    setWorkplaceCode,
    setWorkplaceName,
    setSelectedStatus,
    setStreetName,
  } = useSearches({
    workplaces,
    setWorkplacesSplitted,
    setFilteredWorkplaces,
  });

  const resetFields = useCallback(() => {
    setWorkplaceCode('');
    setWorkplaceName('');
    setSelectedStatus('');
    setStreetName('');
  }, [setSelectedStatus, setStreetName, setWorkplaceCode, setWorkplaceName]);

  const {
    isUpdatingStatus,
    changeStatusModalShow,
    setChangeStatusModalShow,
    workplaceChanginStatus,
    updateWorkplaceStatus,
    handleOpenChangeStatusModal,
  } = useUpdateWorkplaceStatus({ loadWorkplaces, resetFields });

  const {
    isSubmittingFile,
    csvFileName,
    importModalShow,
    handleFileUpload,
    handleSubmitFile,
    setImportModalShow
  } = useUploadFile({
    loadWorkplaces,
  });

  const { downloadExcel } = useDownloadExcel({ fullWorkplacesInfo });

  const pagesQuantity = useMemo(() => workplacesSplitted.length, [workplacesSplitted.length]);

  function handlePageChange(page: number) {
    setCurrentPage(page);
    setFilteredWorkplaces(workplacesSplitted[page]);
  }

  function handleTryAgain() {
    loadWorkplaces();
  }

  const isLoading = isLoadLoading || isUpdatingStatus || isSubmittingFile;

  return {
    isLoading,
    workplaces,
    workplaceCode,
    handleWorkplaceCodeChange,
    streetName,
    handleStreetNameChange,
    handleStatusChange,
    selectedStatus,
    workplaceName,
    handleWorkplaceNameChange,
    hasError: doesListApiHasError,
    filteredWorkplaces,
    pagesQuantity,
    currentPage,
    handlePageChange,
    downloadExcel,
    setImportModalShow,
    handleOpenChangeStatusModal,
    handleTryAgain,
    workplaceChanginStatus,
    setChangeStatusModalShow,
    updateWorkplaceStatus,
    changeStatusModalShow,
    importModalShow,
    csvFileName,
    handleFileUpload,
    handleSubmitFile,
    apiFetched: !doesListApiHasError,
  };
}
